import { supabase } from '@/integrations/supabase/client';

const SUPABASE_URL = "https://tcgfronnpkanfgpqeuep.supabase.co";

export async function workerFetch<T = any>(path: string, options: RequestInit = {}): Promise<T> {
  // Get the current user's session token
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;

  if (!token) {
    throw new Error('Not authenticated');
  }

  const proxyUrl = `${SUPABASE_URL}/functions/v1/worker-proxy?path=${encodeURIComponent(path)}`;

  const response = await fetch(proxyUrl, {
    method: options.method || 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: options.body,
  });

  if (!response.ok) {
    let errorMsg = 'API Error';
    try {
      const error = await response.json();
      errorMsg = error.error || error.message || errorMsg;
    } catch {
      // ignore parse error
    }
    throw new Error(errorMsg);
  }

  return response.json();
}
